import app from 'flarum/forum/app';
import avatar from 'flarum/common/helpers/avatar';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
import UserPage from 'flarum/forum/components/UserPage';
import Placeholder from 'flarum/common/components/Placeholder';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import UnignoreDiscussionModal from './UnignoreDiscussionModal';
export default class IgnoredDiscussionsPage extends UserPage {
  oninit(vdom) {
    this.user = app.session.user;
    this.loading = false;
    this.loadingIgnored = true;
    this.ignoredDiscussions = [];
    if (this.user) {
      this.show(this.user);
    } else {
      app.history.back();
    }
  }
  loadUser(username) {
    // Override to prevent UserPage from trying to load a user from the API
  }
  show(user) {
    super.show(user);
    this.loadIgnoredDiscussions();
  }
  loadIgnoredDiscussions() {
    this.loadingIgnored = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/bizkaitarra/ignored-discussions'
    }).then(payload => {
      const discussions = (payload.data || []).map(discussionData => {
        return app.store.pushObject(discussionData);
      });
      this.ignoredDiscussions = discussions;
      this.loadingIgnored = false;
      m.redraw();
    }).catch(() => {
      this.loadingIgnored = false;
      m.redraw();
    });
  }
  content() {
    return m("div", {
      className: "IgnoredUsersListContainer"
    }, m("h2", {
      className: "IgnoredUsersPage-title"
    }, m("i", {
      className: "fas fa-eye-slash"
    }), ' ', app.translator.trans('bizkaitarra-ignore-users.forum.ignored_discussions_title')), this.loadingIgnored ? m(LoadingIndicator, null) : this.ignoredDiscussions.length === 0 ? m("div", {
      className: "DiscussionList"
    }, m(Placeholder, {
      text: app.translator.trans('bizkaitarra-ignore-users.forum.ignored_discussions_page.no_ignored')
    })) : m("div", {
      className: "IgnoredUsersList"
    }, m("table", {
      className: "NotificationGrid"
    }, m("tbody", null, this.ignoredDiscussions.map((discussion, i) => {
      const unignore = () => {
        app.modal.show(UnignoreDiscussionModal, {
          discussion,
          onunignored: () => {
            this.ignoredDiscussions.splice(i, 1);
            m.redraw();
          }
        });
      };
      const author = discussion.user();
      return m("tr", {
        key: discussion.id()
      }, m("td", null, m("a", {
        href: app.route.discussion(discussion),
        oncreate: m.route.handle
      }, m("div", {
        className: "IgnoredUser-info"
      }, author ? avatar(author, {
        className: 'ignorePage-avatar'
      }) : null, m("span", {
        className: "IgnoredUser-name"
      }, discussion.title())))), m("td", {
        className: "ignorePage-button"
      }, Button.component({
        icon: 'fas fa-eye',
        type: 'button',
        className: 'Button Button--warning',
        onclick: unignore
      }, app.translator.trans('bizkaitarra-ignore-users.forum.discussion_controls.unignore_button'))));
    })))));
  }
}
flarum.reg.add('bizkaitarra-ignore-users', 'forum/components/IgnoredDiscussionsPage', IgnoredDiscussionsPage);